var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cash-flow-report-mapping-row" },
    [
      _c(
        "a-row",
        {
          class: [
            "cash-flow-report-mapping-row__row",
            {
              "cash-flow-report-mapping-row__row--is-editing": _vm.isEditing
            }
          ],
          attrs: {
            gutter: 16,
            justify: "space-around",
            type: "flex",
            align: "stretch"
          }
        },
        [
          _c(
            "a-col",
            { attrs: { span: 5 } },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("lbl_description")))]),
              !_vm.isEditing
                ? _c(
                    "p",
                    { staticClass: "cash-flow-report-mapping-row__name-text" },
                    [_vm._v(" " + _vm._s(_vm.localName) + " ")]
                  )
                : _c("a-input", {
                    attrs: {
                      placeholder: _vm.$t("lbl_description_placeholder")
                    },
                    model: {
                      value: _vm.localName,
                      callback: function($$v) {
                        _vm.localName = $$v
                      },
                      expression: "localName"
                    }
                  })
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { span: 8 } },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("lbl_transaction")))]),
              !_vm.isEditing && _vm.localTransactionTypes.length
                ? _vm._l(_vm.localTransactionTypes, function(type) {
                    return _c(
                      "a-tag",
                      {
                        key: type,
                        staticClass: "cash-flow-report-mapping-row__tag"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.transactionTypeLabelMap.get(type) || type
                            ) +
                            " "
                        )
                      ]
                    )
                  })
                : !_vm.isEditing
                ? _c("span", [_vm._v("-")])
                : _c("CashFlowTransactionTypeSelect", {
                    attrs: {
                      value: _vm.localTransactionTypes,
                      placeholder: _vm.$t("lbl_select_placeholder")
                    },
                    on: { change: _vm.handleTransactionTypeChange }
                  })
            ],
            2
          ),
          _c(
            "a-col",
            { attrs: { span: 8 } },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("lbl_account")))]),
              !_vm.isEditing && _vm.localAccountSecureIds.length
                ? _vm._l(_vm.localAccountSecureIds, function(id) {
                    return _c(
                      "a-tag",
                      {
                        key: id,
                        staticClass: "cash-flow-report-mapping-row__tag"
                      },
                      [_vm._v(" " + _vm._s(_vm.accountLabelMap.get(id)) + " ")]
                    )
                  })
                : !_vm.isEditing
                ? _c("span", [_vm._v("-")])
                : _c("CashFlowAccountSelect", {
                    attrs: {
                      value: _vm.localAccountSecureIds,
                      options: _vm.accountOptions,
                      placeholder: _vm.$t("lbl_select_x", {
                        x: _vm.$t("lbl_account")
                      })
                    },
                    on: { change: _vm.handleAccountChange }
                  })
            ],
            2
          ),
          _c(
            "a-col",
            {
              staticClass: "cash-flow-report-mapping-row__divider-col",
              attrs: { span: 1 }
            },
            [
              _c("a-divider", {
                staticClass: "cash-flow-report-mapping-row__divider",
                attrs: { type: "vertical" }
              })
            ],
            1
          ),
          _c(
            "a-col",
            {
              staticClass: "cash-flow-report-mapping-row__actions-col",
              attrs: { span: 2 }
            },
            [
              !_vm.isEditing
                ? _c(
                    "a-space",
                    [
                      _c("a-button", {
                        attrs: { type: "link", icon: "edit" },
                        on: {
                          click: function($event) {
                            _vm.isEditing = true
                          }
                        }
                      }),
                      _c("a-button", {
                        attrs: { type: "link", icon: "delete" },
                        on: { click: _vm.onDelete }
                      })
                    ],
                    1
                  )
                : _c(
                    "a-space",
                    [
                      _c("a-button", {
                        attrs: { type: "link", icon: "check-circle" },
                        on: { click: _vm.onSave }
                      }),
                      _c("a-button", {
                        attrs: { type: "link", icon: "close-circle" },
                        on: { click: _vm.onCancel }
                      })
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _c("a-divider", {
        staticClass: "cash-flow-report-mapping-row__bottom-divider"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }